import { get } from '../helpers/api';

export const SERVICE_URI = '/pos';
export const BASE_URI = '/api/v1/receipt';

export const getReceiptByOrderId = (orderId) =>
  get(`${SERVICE_URI}${BASE_URI}/order/${orderId}`);
